
import { ref, toRefs, defineComponent, onMounted, watch } from 'vue'
interface Props {
  data: any[]
  dataKey: string
  itemSize: number
  poolBuffer: number
}
export default defineComponent({
  name: 'VirtualList',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    dataKey: {
      type: String,
      default: () => 'id',
    },
    itemSize: {
      type: Number,
      default: () => 60,
    },
    poolBuffer: {
      type: Number,
      default: () => 50,
    },
  },
  setup (props: Props): any {
    const { data, poolBuffer, itemSize } = toRefs(props)
    const virtualRoot = ref<HTMLElement | null>(null) // 外层root
    const pool = ref<any[]>([]) // 数据列表
    const scrollHeight = ref(data.value.length * itemSize.value) // 滚动轴高度

    watch(data, cData => {
      scrollHeight.value = cData.length * itemSize.value
    })
    watch(data, (newValue, oldValue) => {
      console.log('newValue', newValue, 'oldValue', oldValue)
      handleScroll()
    }, {deep: true})

    let containerSize = 0
    const paddingTop = ref(0)
    let isScrollBusy = false
    const handleScroll = () => {
      if (!virtualRoot.value) return
      if (isScrollBusy) return
      isScrollBusy = true
      requestAnimationFrame(() => {
        isScrollBusy = false
        if (!virtualRoot.value) return
        const range: number[] = []
        range[0] =
          Math.floor(virtualRoot.value.scrollTop / itemSize.value) -
          Math.floor(poolBuffer.value / 2)
        range[0] = Math.max(range[0], 0)
        range[1] =
          range[0] +
          Math.floor(virtualRoot.value.clientHeight / itemSize.value) +
          poolBuffer.value
        range[1] = Math.min(range[1], data.value.length)
        pool.value = data.value
          .slice(range[0], range[1])
          .map((v, i) => ({ ...v, _index: range[0] + i }))
        paddingTop.value = range[0] * itemSize.value
      })
    }
    onMounted(() => {
      if (!virtualRoot.value) return
      containerSize = virtualRoot.value.clientHeight
      const contentLines = Math.ceil(containerSize / itemSize.value)
      const totalLines = contentLines + poolBuffer.value
      const range = [0, totalLines]
      pool.value = data.value
        .slice(range[0], range[0] + range[1])
        .map((v, i) => ({ ...v, _index: range[0] + i }))
    })
    return { pool, scrollHeight, virtualRoot, handleScroll, paddingTop }
  },
})
